// import logo from "./logo.svg";
import "./App.css";
import { useState, useEffect } from "react";
import AOS from "aos";

import "aos/dist/aos.css";
// const url = "https://meowfacts.herokuapp.com/";
function App() {
  // Fetches the data from the API
  const [fact, setFact] = useState("");
  const [count, setCount] = useState(1);
  const [facts, setFacts] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
    fetch(`https://meowfacts.herokuapp.com/?count=${count}`)
      .then((response) => response.json())
      .then((data) => {
        if (count === 1) {
          setFact(data.data);
        } else {
          setFacts(data.data);
        }
      })
      .catch((error) => console.error(error));
  }, [count]);

  const handleCountChange = (e) => {
    setCount(e.target.value);
  };

  const handleFetchFact = () => {
    fetch("https://meowfacts.herokuapp.com/")
      .then((response) => response.json())
      .then((data) => setFact(data.data))
      .catch((error) => console.error(error));
  };

  return (
    <main className="maincontent">
      <h1 data-aos="fade-left">Random facts about cats</h1>

      <section data-aos="fade-right">
        {/* <p>{fact}</p> */}

        <label>
          <p>Number of facts to retrieve:</p>
          <input type="number" value={count} onChange={handleCountChange} />
        </label>
        {count === 1 ? (
          <p>{fact}</p>
        ) : (
          <ul>
            {facts.map((fact, index) => (
              <li key={index}>{fact}</li>
            ))}
          </ul>
        )}
        <button
          type="button"
          className="btn"
          id="btn-design"
          data-aos="fade-up"
          onClick={handleFetchFact}
        >
          Change Fact
        </button>
      </section>
      <h3 data-aos="fade-up">Created by Ritik Gupta</h3>
    </main>
  );
}

export default App;
